var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.223,
    height: 65.673,
    viewBox: "0 0 65.223 65.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-request",
    transform: "translate(-3.366 -2.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(3.366 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M63.293,26.22A1.122,1.122,0,0,0,64.415,25.1V16.122A1.122,1.122,0,0,0,63.293,15H34.122A1.122,1.122,0,0,0,33,16.122V25.1a1.122,1.122,0,0,0,1.122,1.122h1.122v2.244H34.122A1.122,1.122,0,0,0,33,29.585v8.976a1.122,1.122,0,0,0,1.122,1.122h1.122v2.244H34.122A1.122,1.122,0,0,0,33,43.049v8.976a1.122,1.122,0,0,0,1.122,1.122H63.293a1.122,1.122,0,0,0,1.122-1.122V43.049a1.122,1.122,0,0,0-1.122-1.122H62.171V39.683h1.122a1.122,1.122,0,0,0,1.122-1.122V29.585a1.122,1.122,0,0,0-1.122-1.122H62.171V26.22ZM35.244,17.244H62.171v6.732H35.244ZM62.171,50.9H35.244V44.171H62.171Zm-2.244-8.976H37.488V39.683H59.927Zm2.244-4.488H35.244V30.707H62.171Zm-2.244-8.976H37.488V26.22H59.927Z",
    transform: "translate(0.659 -1.537)",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M38.122,21.244H47.1A1.122,1.122,0,1,0,47.1,19H38.122a1.122,1.122,0,1,0,0,2.244Z",
    transform: "translate(1.146 -1.049)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(58.634 18)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M47.1,31H38.122a1.122,1.122,0,1,0,0,2.244H47.1A1.122,1.122,0,1,0,47.1,31Z",
    transform: "translate(1.146 0.415)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(58.634 31)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M47.1,43H38.122a1.122,1.122,0,1,0,0,2.244H47.1A1.122,1.122,0,1,0,47.1,43Z",
    transform: "translate(1.146 1.878)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(58.634 45)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M17.585,46.928a5.61,5.61,0,0,0,5.61-5.61,10.1,10.1,0,0,0-6.025-9.234,6.732,6.732,0,1,0-8.145,0A10.1,10.1,0,0,0,3,41.318a5.61,5.61,0,0,0,5.61,5.61ZM8.61,26.733A4.488,4.488,0,1,1,13.1,31.22,4.488,4.488,0,0,1,8.61,26.733ZM5.244,41.318a7.854,7.854,0,0,1,15.707,0,3.366,3.366,0,0,1-3.366,3.366H8.61A3.366,3.366,0,0,1,5.244,41.318Z",
    transform: "translate(-3 -0.928)",
    fill: "#a86b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M12.122,16.463a1.122,1.122,0,0,0,1.122-1.122V8.61A3.366,3.366,0,0,1,16.61,5.244h35.9A3.366,3.366,0,0,1,55.878,8.61v2.244l-2.693-2.02a1.122,1.122,0,1,0-1.346,1.8L56.327,14l.146.079.135.067a1.021,1.021,0,0,0,.785,0l.135-.067L57.673,14l4.488-3.366a1.122,1.122,0,0,0-1.346-1.8l-2.693,2.02V8.61A5.61,5.61,0,0,0,52.512,3H16.61A5.61,5.61,0,0,0,11,8.61v6.732A1.122,1.122,0,0,0,12.122,16.463Z",
    transform: "translate(-2.024 -3)",
    stroke: "#000",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M57.487,51.244a1.122,1.122,0,0,0-1.122,1.122v4.488A3.366,3.366,0,0,1,53,60.22H17.1a3.366,3.366,0,0,1-3.366-3.366V52.366l2.693,2.02a1.122,1.122,0,1,0,1.346-1.8l-4.488-3.366-.146-.079L13,49.079A1.122,1.122,0,0,0,12.609,49h0a1.122,1.122,0,0,0-.381.079l-.135.067-.146.079L7.459,52.59a1.122,1.122,0,1,0,1.346,1.8l2.681-2.02v4.488a5.61,5.61,0,0,0,5.61,5.61H53a5.61,5.61,0,0,0,5.61-5.61V52.366A1.122,1.122,0,0,0,57.487,51.244Z",
    transform: "translate(-2.511 2.61)",
    stroke: "#000",
    strokeWidth: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.361dc68697bb2c142e2922d9c90bd648.svg";
export { ForwardRef as ReactComponent };